import { Modal, Button } from "react-bootstrap";

interface NoRecipientModalProps {
  show: boolean;
  onHide: () => void;
  onAddRecipient: () => void;
  onStartAnyway: () => void;
}

const NoRecipientModal = ({ show, onHide, onAddRecipient, onStartAnyway }: NoRecipientModalProps) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px", fontWeight: 600 }}>No recipients found</Modal.Title>
      </Modal.Header>
      <Modal.Body>There is no recipient to receive this campaign. Please continue.</Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onAddRecipient} className="rounded">
          Add recipient
        </Button>
        <Button variant="primary" onClick={onStartAnyway} className="rounded">
          Start anyway
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NoRecipientModal;
